module.exports = __webpack_public_path__ + "static/media/game3.03cf15aa.png";